export default function () {
  return {
    feedback: {},
    logs: {},
    listeners: {},
  };
}
